import React from 'react';
import { Box } from '@mui/material';
import VideoPlayerSection from './VideoPlayerSection';
import TranscriptSection from '../Video/TranscriptSection';
import SummarySection from '../Summary/SummarySection';
import QASection from '../QA/QASection';
import { SPACING } from '../../constants';

const DesktopLayout = ({
  // 비디오 관련
  isStreaming,
  analyzedVideoId,
  analyzedTitle,
  analyzedUrl,
  selectedHistory,
  onPlayerStateChange,
  playerRef,
  // 자막 관련
  scriptArr,
  activeIdx,
  autoScroll,
  setAutoScroll,
  scriptRefs,
  transcriptLoading,
  showTranslated,
  handleToggleTranslation,
  currentTranscript,
  // 요약 관련
  loading,
  streamingSummary,
  streamingChapters,
  activeTab,
  setActiveTab,
  streamingChunkSummaries,
  // QA 관련
  qaInput,
  setQaInput,
  qaLoading,
  handleQaSend,
  qaHistory,
  recommendedQuestions,
  handleRecommendedQuestionClick,
  qaScrollRef
}) => {
  return (
    <Box sx={{ display: 'flex', height: '100%', gap: `${SPACING}px`, alignItems: 'stretch' }}>
      {/* 컬럼 1: 비디오 플레이어 + 자막 (25% 비율) */}
      <Box sx={{ flexGrow: 25, flexBasis: 0, minWidth: 0, minHeight: 0, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <VideoPlayerSection
          videoId={isStreaming ? analyzedVideoId : selectedHistory?.videoId}
          title={isStreaming ? analyzedTitle : selectedHistory?.title}
          onPlayerStateChange={onPlayerStateChange}
          playerRef={playerRef}
          isMobile={false}
        />
        
        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <TranscriptSection
            scriptArr={scriptArr}
            activeIdx={activeIdx}
            autoScroll={autoScroll}
            setAutoScroll={setAutoScroll}
            scriptRefs={scriptRefs}
            playerRef={playerRef}
            loading={transcriptLoading}
            transcript={selectedHistory?.transcript}
            translatedTranscript={selectedHistory?.translatedTranscript}
            showTranslated={showTranslated}
            onToggleTranslation={handleToggleTranslation}
            key={selectedHistory?.id}
          />
        </Box>
      </Box>

      {/* 컬럼 2: 요약 섹션 (40% 비율) */}
      <Box sx={{ flexGrow: 40, flexBasis: 0, minWidth: 0, minHeight: 0, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          <SummarySection
            summaryLoading={loading}
            summary={streamingSummary || selectedHistory?.summary || ''}
            detailContent={
              streamingChapters.length > 0
                ? streamingChapters
                : (Array.isArray(selectedHistory?.chapters)
                    ? selectedHistory.chapters
                    : selectedHistory?.chapters?.chapters || [])
            }
            isStreaming={isStreaming}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            playerRef={playerRef}
            streamingChunkSummaries={
              streamingChunkSummaries.length > 0
                ? streamingChunkSummaries
                : selectedHistory?.chunk_summaries || []
            }
            transcript={currentTranscript}
            setActiveMainTab={null}
            videoUrl={isStreaming ? analyzedUrl : selectedHistory?.url}
            videoTitle={isStreaming ? analyzedTitle : selectedHistory?.title}
            key={selectedHistory?.id}
          />
        </Box>
      </Box>

      {/* 컬럼 3: QA 섹션 (30% 비율) */}
      <Box sx={{ flexGrow: 30, flexBasis: 0, minWidth: 0, minHeight: 0, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          <QASection
            qaInput={qaInput}
            setQaInput={setQaInput}
            qaLoading={qaLoading}
            handleQaSend={handleQaSend}
            qaHistory={qaHistory}
            recommendedQuestions={recommendedQuestions}
            handleRecommendedQuestionClick={handleRecommendedQuestionClick}
            qaScrollRef={qaScrollRef}
            summary={selectedHistory?.summary}
            chapters={
              Array.isArray(selectedHistory?.chapters)
                ? selectedHistory.chapters
                : selectedHistory?.chapters?.chapters || []
            }
            key={selectedHistory?.id}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DesktopLayout; 